import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

/**
 * 지점 삭제 / 해제
 *
 * 지점(LV6)은 'Y'(삭제)만, 본점(LV8/9)은 'N'(해제)만 보낼 수 있다.
 * 지점 화면에서만 숨겨지고 본점 데이터는 그대로 남는다.
 */
interface BranchDeleteRequest {
    order_idx: number[];
    branch_del: "Y" | "N";
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutBranchDelete = (
    successCallback?: () => void,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, BranchDeleteRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, AxiosError<ApiErrorResponse>, BranchDeleteRequest>({
        mutationFn: async ({ order_idx, branch_del }: BranchDeleteRequest) => {
            const response = await axios.put(
                `${enum_api_uri.put_order_branch_delete}`,
                { order_idx, branch_del },
                { headers: { Authorization: `Bearer ${accessToken}` } },
            );
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderCount"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderDateCount"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            successCallback?.();
        },
    });
};
